module.exports = __webpack_public_path__ + "static/media/portfolio-11.a2d324ee.webp";